export default "__VITE_ASSET__BbdUeqol__"